export function Mark({ className = "" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
      <path d="M12 2.5 L21.5 12 L12 21.5 L2.5 12 Z" stroke="currentColor" strokeWidth="1.4" />
      <path d="M12 7.5 L16.5 12 L12 16.5 L7.5 12 Z" fill="currentColor" />
    </svg>
  );
}
